module.exports = [
	'Male',
	'Female',
	'Prefer not to say'
]


//////////////////
// WEBPACK FOOTER
// ../server/constants/genders.js
// module id = 1192
// module chunks = 0